// sides: number of straight sides (null = curved / not applicable)
// vertices: number of corners
// angles: human-readable angle description
// area: formula string shown as answer option
// areaDesc: plain-English description of the formula (used as distractor label)
// areaQ: the question asked for area mode
export const SHAPES = [
  {
    name: "Circle",
    tag: "circle",
    viewBox: "0 0 140 140",
    attrs: { cx: 70, cy: 70, r: 60 },
    sides: 0, vertices: 0,
    angles: "No corners - it is a curved shape",
    area: "π × r²",
    areaQ: "What is the area formula for a circle?",
  },
  {
    name: "Square",
    tag: "rect",
    viewBox: "0 0 140 140",
    attrs: { x: 20, y: 20, width: 100, height: 100 },
    sides: 4, vertices: 4,
    angles: "4 right angles (90°)",
    area: "s²",
    areaQ: "What is the area formula for a square?",
  },
  {
    name: "Rectangle",
    tag: "rect",
    viewBox: "0 0 140 140",
    attrs: { x: 10, y: 35, width: 120, height: 70 },
    sides: 4, vertices: 4,
    angles: "4 right angles (90°)",
    area: "l × w",
    areaQ: "What is the area formula for a rectangle?",
  },
  {
    name: "Triangle",
    viewBox: "0 0 140 140",
    path: "M70 10 L130 130 L10 130 Z",
    sides: 3, vertices: 3,
    angles: "3 angles that sum to 180°",
    area: "½ × b × h",
    areaQ: "What is the area formula for a triangle?",
  },
  {
    name: "Right Triangle",
    viewBox: "0 0 140 140",
    path: "M10 130 L130 130 L10 10 Z",
    sides: 3, vertices: 3,
    angles: "One 90° angle; other two sum to 90°",
    area: "½ × b × h",
    areaQ: "What is the area formula for a right triangle?",
  },
  {
    name: "Parallelogram",
    viewBox: "0 0 140 140",
    path: "M30 110 L50 30 L130 30 L110 110 Z",
    sides: 4, vertices: 4,
    angles: "2 pairs of equal opposite angles",
    area: "b × h",
    areaQ: "What is the area formula for a parallelogram?",
  },
  {
    name: "Trapezoid",
    viewBox: "0 0 140 140",
    path: "M30 110 L110 110 L130 30 L10 30 Z",
    sides: 4, vertices: 4,
    angles: "4 angles; co-interior angles sum to 180°",
    area: "½ × (a + b) × h",
    areaQ: "What is the area formula for a trapezoid?",
  },
  {
    name: "Rhombus",
    viewBox: "0 0 140 140",
    path: "M70 10 L125 70 L70 130 L15 70 Z",
    sides: 4, vertices: 4,
    angles: "2 pairs of equal opposite angles",
    area: "½ × d₁ × d₂",
    areaQ: "What is the area formula for a rhombus?",
  },
  {
    name: "Diamond",
    viewBox: "0 0 140 140",
    path: "M70 10 L130 70 L70 130 L10 70 Z",
    sides: 4, vertices: 4,
    angles: "2 pairs of equal opposite angles",
    area: "½ × d₁ × d₂",
    areaQ: "What is the area formula for a diamond (rhombus)?",
  },
  {
    name: "Kite",
    viewBox: "0 0 140 140",
    path: "M70 8 L120 60 L70 132 L20 60 Z",
    sides: 4, vertices: 4,
    angles: "One pair of equal opposite angles",
    area: "½ × d₁ × d₂",
    areaQ: "What is the area formula for a kite?",
  },
  {
    name: "Pentagon",
    viewBox: "0 0 140 140",
    path: "M70 8 L133 54 L108 126 L32 126 L7 54 Z",
    sides: 5, vertices: 5,
    angles: "5 interior angles summing to 540°",
    area: "¼ × √(5(5+2√5)) × s²",
    areaQ: "How many sides does a regular pentagon have?",
  },
  {
    name: "Hexagon",
    viewBox: "0 0 140 140",
    path: "M70 8 L122 38 L122 102 L70 132 L18 102 L18 38 Z",
    sides: 6, vertices: 6,
    angles: "6 interior angles summing to 720°",
    area: "(3√3 / 2) × s²",
    areaQ: "What is the area formula for a regular hexagon?",
  },
  {
    name: "Heptagon",
    viewBox: "0 0 140 140",
    path: "M70 8 L116 24 L134 72 L112 118 L70 132 L28 118 L6 72 L24 24 Z",
    sides: 7, vertices: 7,
    angles: "7 interior angles summing to 900°",
    area: "No simple formula (7-sided)",
    areaQ: "How many sides does a heptagon have?",
  },
  {
    name: "Octagon",
    viewBox: "0 0 140 140",
    path: "M45 8 L95 8 L132 45 L132 95 L95 132 L45 132 L8 95 L8 45 Z",
    sides: 8, vertices: 8,
    angles: "8 interior angles summing to 1080°",
    area: "2(1+√2) × s²",
    areaQ: "How many sides does a regular octagon have?",
  },
  {
    name: "Oval",
    tag: "ellipse",
    viewBox: "0 0 140 140",
    attrs: { cx: 70, cy: 70, rx: 65, ry: 40 },
    sides: 0, vertices: 0,
    angles: "No corners - it is a curved shape",
    area: "π × a × b",
    areaQ: "What is the area formula for an ellipse (oval)?",
  },
  {
    name: "Semicircle",
    viewBox: "0 0 140 140",
    path: "M10 80 A60 60 0 0 1 130 80 Z",
    sides: 1, vertices: 2,
    angles: "One straight edge; curved top",
    area: "½ × π × r²",
    areaQ: "What is the area formula for a semicircle?",
  },
  {
    name: "Equilateral Triangle",
    viewBox: "0 0 140 140",
    path: "M70 8 L134 126 L6 126 Z",
    sides: 3, vertices: 3,
    angles: "3 equal angles of 60° each",
    area: "(√3 / 4) × s²",
    areaQ: "What is the area formula for an equilateral triangle?",
  },
  {
    name: "5-Point Star",
    viewBox: "0 0 140 140",
    path: "M70 8 L83 50 L126 50 L92 75 L105 117 L70 92 L35 117 L48 75 L14 50 L57 50 Z",
    sides: 10, vertices: 10,
    angles: "10 vertices; 5 outer (36°) and 5 inner angles",
    area: null,
    areaQ: "How many points does this star have?",
  },
  {
    name: "Cross",
    viewBox: "0 0 140 140",
    path: "M50 8 L90 8 L90 50 L132 50 L132 90 L90 90 L90 132 L50 132 L50 90 L8 90 L8 50 L50 50 Z",
    sides: 12, vertices: 12,
    angles: "12 sides; all angles are 90° or 270°",
    area: null,
    areaQ: "How many sides does a cross shape have?",
  },
  {
    name: "L-Shape",
    viewBox: "0 0 140 140",
    path: "M20 10 L60 10 L60 90 L120 90 L120 130 L20 130 Z",
    sides: 6, vertices: 6,
    angles: "6 sides; four 90° angles and two 270° angles",
    area: null,
    areaQ: "How many sides does an L-shape have?",
  },
  {
    name: "T-Shape",
    viewBox: "0 0 140 140",
    path: "M10 10 L130 10 L130 50 L85 50 L85 130 L55 130 L55 50 L10 50 Z",
    sides: 8, vertices: 8,
    angles: "8 sides; mix of 90° and 270° angles",
    area: null,
    areaQ: "How many sides does a T-shape have?",
  },
];
